import { __experimentalHeading as Heading } from '@wordpress/components';
import SynchronisationPanel from '@components/Settings/SynchronisationPanel';

export const SettingsPanel = () => {
  return (
    <div className="settings-panel wrap">
      <Heading>Blockbite Settings</Heading>
      <SynchronisationPanel />
    </div>
  );
};

export default SettingsPanel;
